import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCourse } from '../../../services/MoodleService';
import { moodleQueryKeys } from '../all-query-keys';

export const useUpdateCourse = (onSuccess) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: updateCourse,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: moodleQueryKeys.getConfiguredCourses(),
      });
      onSuccess?.(...args);
    },
  });

  return { mutate, isPending };
};
